module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-1-Inactive-ClubPilates-ed7e1cb1a45118f7ed3767841abfe12c.png";